import checkboxStyle from '../../mui-pro/assets/jss/material-kit-pro-react/customCheckboxRadioSwitchStyle';

const checkboxStyles = theme => ({
  ...checkboxStyle
});

export default checkboxStyles;
